function venddSetCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; " + "path=/";
}

function venddGetCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

function toArrayBuffer(buf) {
	var ab = new ArrayBuffer(buf.length);
	var view = new Uint8Array(ab);
	for (var i = 0; i < buf.length; ++i) {
		view[i] = buf[i];
	}
	return ab;
}

var decodeEntities = (function() {
    var element = document.createElement('div');
  
    function decodeHTMLEntities (str) {
      if(str && typeof str === 'string') {
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = '';
      }
  
      return str;
    }
  
    return decodeHTMLEntities;
  })();

function allowOnlyNumbersInput($container) {

    if (!$container || $container.length < 0) $container = $('html');

    $('*[data-only-numbers="true"]', $container).keyup(function () {
        var value = this.value.replace(/[^0-9\.,]/g, '');

        if (this.value != value) {
            this.value = value;
        }
    });
}

function stringToNumber(value) {

    var returnValue, currency, decimal, val = "" + value;

    currency = LhApp.Context.Currency.Symbol;
    decimal = LhApp.Context.Currency.DecimalSeparator;
    returnValue = val.replace(currency, '').replace(decimal, '.').trim();

    return parseFloat(returnValue).toFixed(venddProjectConfigs.NumberOfDecimals ? venddProjectConfigs.NumberOfDecimals : 2);
}

function numberToString(value, addCurrency, clearZeros) {
    var returnValue, currency, decimal, fractional, val = "" + value;

    currency = LhApp.Context.Currency.Symbol;
    decimal = LhApp.Context.Currency.DecimalSeparator;
    returnValue = val.replace(currency, '').replace('.', decimal).trim();


    if (clearZeros) {
        fractional = returnValue.split(decimal);
     
        if (fractional.length > 1) {
            if (new RegExp("^[0\0]+$").test(fractional[1])) {
                returnValue = fractional[0];
            }
        }         
    }
        
    if (addCurrency)
        returnValue += " " + currency;

    return returnValue;
}

var contains = function (array, item) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] === item) {
            return true;
        }
    }
    return false;
};